<template>
    <vs-button color="primary" type="flat" @click.native="reloadPage">
        <font-awesome-icon :icon="['fas', 'redo']" class="fa-icon" />
        Pagina herladen
    </vs-button>
</template>

<script>
export default {
	methods: {
		reloadPage() {
			window.location.reload();
		},
	}
}
</script>
